const DATA_ACCESS_API_CONFIGURATION = {
  empty: {
    description:
      'Create an agent first to be able to configure the data access',
    title: 'No configurations available',
  },
};

export default DATA_ACCESS_API_CONFIGURATION;
